var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 925",
    d: "M10 5H24V21C24 22.6569 22.6569 24 21 24H10V5Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 926",
    x: 7,
    y: 14,
    width: 3,
    height: 10,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 255",
    d: "M7.5 24C8.88071 24 10 22.8446 10 21.4194V14H5V21.4194C5 22.8446 6.11929 24 7.5 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M25.3862 7.38617L24.8148 13.622L23.1412 11.9484L18.5448 16.5448L16.0345 14.0344L20.6309 9.43808L18.5448 7.38617L25.3862 7.38617Z",
    fill: "#50C0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 927",
    x: 12,
    y: 19,
    width: 10,
    height: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepDark);
export default __webpack_public_path__ + "static/media/prep_dark.5c9410960ef888922385941fce98e8a3.svg";
export { ForwardRef as ReactComponent };